<template>
    <div class="mt-1">
        <b-form-select
            v-model="option"
            :options="accountingFirmUsers"
            :disabled="disableSelect"
            size="sm"
            @change="setFilter"
        >
            <template #first>
                <b-form-select-option :value="0" disabled>
                    Sélectionner un collaborateur
                </b-form-select-option>
            </template>
        </b-form-select>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'AccountingFirmUserSelect',

    mixins: [DataUpdater],

    data() {
        return {
            option: 0,
        }
    },

    computed: {
        ...mapState({
            filters: (state) => state.timeSheetsVM.filters,
            filterOptions: (state) => state.data.options,
            viewAllTimeSheets: (state) => state.timeSheetsVM.viewAllTimeSheets,
            pageName: (state) => state.browsing.pageName,
        }),

        accountingFirmUsers() {
            return this.filterOptions.accountingFirmUsers.filter(
                (item) => item.value !== 0
            )
        },

        disableSelect() {
            if (
                this.pageName === 'pivotChargeCollaborator' ||
                this.pageName === 'chargeTableCollaborator'
            ) {
                return false
            } else {
                return !this.viewAllTimeSheets
            }
        },
    },

    mounted() {
        // await this.filters
        this.option = this.filters.accountingFirmUser
    },

    methods: {
        async setFilter() {
            await this.$store.commit(
                'timeSheetsVM/SET_ACCOUNTING_FIRM_USER_OPTION',
                this.option
            )
            this.$emit('collaborator-has-changed')
            // this.updateData()
        },
    },
}
</script>

<style scoped></style>
